(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var cfg = window.SneakPen = window.SneakPen || {};
  var routes = cfg.routes || {};
  var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reduced() { return !!(reduceMq && reduceMq.matches); }
  function str(key) { return (cfg.strings && cfg.strings[key]) || ''; }
  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, name) {
      return values && values[name] != null ? values[name] : match;
    });
  }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function focusSafely(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function isShown(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '€{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return whole + fraction;
    }
    var match = fmt.match(placeholder);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value).replace(/<[^>]*>/g, '');
  }
  cfg.formatMoney = formatMoney;

  var lockCount = 0;
  function lockScroll() {
    if (lockCount++ === 0) {
      var bar = window.innerWidth - root.clientWidth;
      root.style.setProperty('--sbw', (bar > 0 ? bar : 0) + 'px');
      root.classList.add('is-locked');
    }
  }
  function unlockScroll() {
    if (lockCount === 0) return;
    lockCount -= 1;
    if (lockCount === 0) {
      root.classList.remove('is-locked');
      root.style.removeProperty('--sbw');
    }
  }
  cfg.lockScroll = lockScroll;
  cfg.unlockScroll = unlockScroll;

  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), iframe, summary, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  function focusables(container) {
    if (!container) return [];
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      if (el.closest('[hidden], [inert]')) return false;
      if (!isShown(el)) return false;
      return window.getComputedStyle(el).visibility !== 'hidden';
    });
  }

  var inerted = [];
  function setBackgroundInert(modalEl, on) {
    if (!on) {
      inerted.forEach(function (el) { el.removeAttribute('inert'); });
      inerted = [];
      return;
    }
    Array.prototype.forEach.call(doc.body.children, function (el) {
      if (el.contains(modalEl) || el.hasAttribute('inert')) return;
      if (el.matches('script, style, template, link, [data-bag-close], [data-toast]')) return;
      el.setAttribute('inert', '');
      inerted.push(el);
    });
    var nav = doc.getElementById('nav');
    if (nav && !nav.contains(modalEl) && nav.parentNode && nav.parentNode.contains(modalEl) && !nav.hasAttribute('inert')) {
      nav.setAttribute('inert', '');
      inerted.push(nav);
    }
  }

  var modalStack = [];
  var modalRegistry = [];

  function Modal(opts) {
    var m = { isOpen: false, lastFocus: null };
    m.contains = function (node) { return opts.el.contains(node); };
    m.focusables = function () { return focusables(opts.trapEl || opts.el); };
    m.open = function (opener) {
      if (m.isOpen) return;
      modalRegistry.forEach(function (other) { if (other !== m && other.isOpen) other.close(false); });
      m.isOpen = true;
      m.lastFocus = opener || doc.activeElement;
      lockScroll();
      modalStack.push(m);
      opts.show();
      setBackgroundInert(opts.el, true);
      focusSafely((opts.initialFocus && opts.initialFocus()) || opts.el);
    };
    m.close = function (restoreFocus) {
      if (!m.isOpen) return;
      m.isOpen = false;
      var i = modalStack.indexOf(m);
      if (i > -1) modalStack.splice(i, 1);
      setBackgroundInert(opts.el, false);
      opts.hide();
      unlockScroll();
      if (restoreFocus === false) return;
      var back = m.lastFocus;
      if (!back || !doc.body.contains(back) || !isShown(back) || opts.el.contains(back)) {
        back = opts.fallbackFocus ? opts.fallbackFocus() : null;
      }
      focusSafely(back);
    };
    modalRegistry.push(m);
    return m;
  }

  doc.addEventListener('keydown', function (e) {
    var m = modalStack[modalStack.length - 1];
    if (!m) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      m.close();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = m.focusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    var active = doc.activeElement;
    var inside = list.indexOf(active) > -1;
    if (!inside && active && m.contains(active)) {
      var rest = list.filter(function (el) { return active.compareDocumentPosition(el) & (e.shiftKey ? 2 : 4); });
      if (rest.length) { e.preventDefault(); focusSafely(e.shiftKey ? rest[rest.length - 1] : rest[0]); return; }
    }
    if (e.shiftKey) {
      if (active === first || !inside) { e.preventDefault(); focusSafely(last); }
    } else if (active === last || !inside) {
      e.preventDefault();
      focusSafely(first);
    }
  });

  doc.addEventListener('focusin', function (e) {
    var m = modalStack[modalStack.length - 1];
    if (!m || m.contains(e.target)) return;
    var list = m.focusables();
    if (list.length) focusSafely(list[0]);
  });

  function initNav() {
    var annBottom = 0;
    var lastTop = -1;
    var ticking = false;
    var needsMeasure = false;
    var observer = null;

    function measure() {
      var ann = doc.querySelector('[data-announcement]');
      if (!ann || ann.hidden) { annBottom = 0; return; }
      var rect = ann.getBoundingClientRect();
      annBottom = rect.bottom + (window.pageYOffset || root.scrollTop || 0);
    }
    function update() {
      ticking = false;
      if (needsMeasure) { needsMeasure = false; measure(); }
      var y = window.pageYOffset || root.scrollTop || 0;
      var nav = doc.getElementById('nav');
      if (nav) nav.classList.toggle('is-scrolled', y > 24);
      var top = Math.max(0, Math.round(annBottom - y));
      if (top !== lastTop) {
        lastTop = top;
        root.style.setProperty('--nav-top', top + 'px');
      }
    }
    function request(remeasure) {
      if (remeasure === true) needsMeasure = true;
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    function remeasure() { request(true); }
    function observe() {
      if (!('ResizeObserver' in window)) return;
      if (observer) observer.disconnect();
      observer = new ResizeObserver(function () { request(true); });
      var ann = doc.querySelector('[data-announcement]');
      if (ann) observer.observe(ann);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('orientationchange', remeasure, { passive: true });
    doc.addEventListener('shopify:section:load', function () { observe(); request(true); });
    doc.addEventListener('shopify:section:unload', function () { request(true); });
    measure();
    observe();
    update();
  }

  function initMenu() {
    var modal = null;
    var menuEl = null;
    var hideTimer = null;

    function build() {
      var menu = doc.getElementById('mobileMenu');
      if (!menu) return null;
      if (menu === menuEl && modal) return modal;
      if (modal && modal.isOpen) modal.close(false);
      menuEl = menu;
      modal = Modal({
        el: menu,
        show: function () {
          clearTimeout(hideTimer);
          menu.hidden = false;
          void menu.offsetWidth; // commit the shown state so the fade runs
          menu.classList.add('is-open');
          var toggle = doc.getElementById('navToggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        },
        hide: function () {
          menu.classList.remove('is-open');
          var toggle = doc.getElementById('navToggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          if (reduced()) menu.hidden = true;
          else hideTimer = setTimeout(function () { menu.hidden = true; }, 340);
        },
        initialFocus: function () { return menu.querySelector('[data-menu-close]'); },
        fallbackFocus: function () { return doc.getElementById('navToggle'); }
      });
      return modal;
    }

    doc.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var toggle = target.closest('#navToggle');
      if (toggle) {
        var m = build();
        if (!m) return;
        if (m.isOpen) m.close();
        else m.open(toggle);
        return;
      }
      if (!modal || !modal.isOpen || !menuEl || !menuEl.contains(target)) return;
      if (target.closest('[data-menu-close]')) { modal.close(); return; }
      var link = target.closest('a[href]');
      if (link && !link.hasAttribute('data-search-toggle')) modal.close(false);
    });

    if (window.matchMedia) {
      var desktop = window.matchMedia('(min-width: 1025px)');
      var onChange = function () { if (desktop.matches && modal && modal.isOpen) modal.close(false); };
      if (desktop.addEventListener) desktop.addEventListener('change', onChange);
      else if (desktop.addListener) desktop.addListener(onChange);
    }
  }

  function kitKey(handle, title) {
    var h = String(handle || '').toLowerCase();
    var probe = (h + ' ' + String(title || '')).toLowerCase();
    var duo = probe.indexOf('+1') > -1 || probe.indexOf('plus') > -1 || probe.indexOf('duo') > -1 ||
      probe.indexOf('pack') > -1 || h.indexOf('-1') > -1;
    if (probe.indexOf('roller') > -1) return 'rollers';
    if (probe.indexOf('printer') > -1) return 'printer';
    if (probe.indexOf('full') > -1) return duo ? 'full-duo' : 'full';
    if (probe.indexOf('pen kit') > -1 || probe.indexOf('pen-kit') > -1) return duo ? 'pen-duo' : 'pen';
    return '';
  }
  function kitThumb(handle, title) {
    var key = kitKey(handle, title);
    return (key && cfg.kitThumbs && cfg.kitThumbs[key]) || '';
  }
  function sized(url, width) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('/assets/') > -1) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  cfg.kitKey = kitKey;
  cfg.kitThumb = kitThumb;

  function initSearch() {
    var panel = doc.getElementById('searchPanel');
    if (!panel) return;
    var dialog = panel.querySelector('[role="dialog"]') || panel;
    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var hint = panel.querySelector('[data-search-hint]');
    var allLink = panel.querySelector('[data-search-all]');
    var timer = null;
    var controller = null;
    var lastQuery = '';

    var modal = Modal({
      el: panel,
      trapEl: dialog,
      show: function () { panel.hidden = false; },
      hide: function () { panel.hidden = true; abort(); clearTimeout(timer); },
      initialFocus: function () { return input; },
      fallbackFocus: function () { return doc.querySelector('.nav__search'); }
    });

    function abort() {
      if (controller && controller.abort) controller.abort();
      controller = null;
    }

    function reset() {
      lastQuery = '';
      if (results && hint) { results.innerHTML = ''; results.appendChild(hint); }
      if (allLink) allLink.hidden = true;
    }

    function thumb(url, handle, title) {
      var src = url ? sized(url, 120) : kitThumb(handle, title);
      if (!src) return '<span class="psearch__thumb" aria-hidden="true"></span>';
      return '<span class="psearch__thumb" aria-hidden="true"><img src="' + esc(src) + '" alt="" width="48" height="48" loading="lazy"></span>';
    }

    function priceOf(item) {
      if (item.available === false && str('soldOut')) return '<span class="psearch__price psearch__price--soon">' + esc(str('soldOut')) + '</span>';
      var min = Math.round(parseFloat(item.price_min || item.price) * 100);
      var max = Math.round(parseFloat(item.price_max || item.price) * 100);
      if (isNaN(min)) return '';
      if (min <= 0) {
        var soon = str('comingSoon');
        return soon ? '<span class="psearch__price psearch__price--soon">' + esc(soon) + '</span>' : '';
      }
      var text = formatMoney(min);
      if (!isNaN(max) && max > min && str('priceFrom')) text = fill(str('priceFrom'), { price: text });
      return '<span class="psearch__price">' + esc(text) + '</span>';
    }

    function row(item, kind) {
      var image = kind === 'product'
        ? thumb(item.featured_image && item.featured_image.url ? item.featured_image.url : item.image, item.handle, item.title)
        : '';
      var meta = kind === 'product'
        ? ''
        : '<span class="psearch__meta">' + esc(kind === 'article' ? str('kindArticle') : str('kindPage')) + '</span>';
      return '<a class="psearch__item" href="' + esc(item.url) + '">' + image +
        '<span class="psearch__text"><span class="psearch__title">' + esc(item.title) + '</span>' + meta + '</span>' +
        (kind === 'product' ? priceOf(item) : '') + '</a>';
    }

    function group(label, items, kind) {
      if (!items || !items.length) return '';
      return '<p class="psearch__group">' + esc(label) + '</p>' + items.map(function (it) { return row(it, kind); }).join('');
    }

    function render(data, query) {
      if (!results || query !== lastQuery) return;
      var r = (data && data.resources && data.resources.results) || {};
      var html = group(str('searchProducts'), r.products, 'product') +
        group(str('searchPages'), r.pages, 'page') +
        group(str('searchArticles'), r.articles, 'article');
      if (!html) html = '<p class="psearch__empty">' + esc(str('noResults')) + '</p>';
      results.innerHTML = html;
      var status = panel.querySelector('[data-search-status]');
      if (status) {
        var count = (r.products || []).length + (r.pages || []).length + (r.articles || []).length;
        status.textContent = count ? fill(str('searchCount'), { count: count }) : str('noResults');
      }
      if (allLink) {
        allLink.hidden = false;
        allLink.href = (routes.search_url || '/search') + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
      }
    }

    function search(query) {
      abort();
      lastQuery = query;
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = (routes.predictive_search_url || '/search/suggest') +
        '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,page,article&resources[limit]=4&resources[limit_scope]=each';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) { render(data, query); })
        .catch(function () {});
    }

    doc.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var toggle = target.closest('[data-search-toggle]');
      if (toggle) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        if (input) input.value = '';
        reset();
        modal.open(toggle);
        return;
      }
      if (modal.isOpen && target.closest('[data-search-close]')) modal.close();
    });

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { abort(); reset(); return; }
        timer = setTimeout(function () { search(q); }, 220);
      });
    }

    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = results ? Array.prototype.slice.call(results.querySelectorAll('.psearch__item')) : [];
      if (!items.length) return;
      var i = items.indexOf(doc.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusSafely(items[i < 0 ? 0 : Math.min(i + 1, items.length - 1)]);
      } else if (i > -1) {
        e.preventDefault();
        focusSafely(i === 0 ? input : items[i - 1]);
      }
    });
  }

  function initReveals() {
    var els = Array.prototype.slice.call(doc.querySelectorAll('.reveal'));
    if (!els.length) return;
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    function showAll() { els.forEach(function (el) { el.classList.add('is-in'); }); }
    if (!('IntersectionObserver' in window) || designMode || reduced()) { showAll(); return; }

    var vh = window.innerHeight || root.clientHeight;
    var rects = els.map(function (el) { return el.getBoundingClientRect(); });
    var pending = els.filter(function (el, i) {
      var r = rects[i];
      if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); return false; }
      return true;
    });
    if (!pending.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    pending.forEach(function (el) { io.observe(el); });
    root.classList.add('reveal-on');
    window.addEventListener('beforeprint', showAll);
  }

  function toast(message, kind) {
    if (!message) return;
    var el = doc.querySelector('[data-toast]');
    if (!el) {
      el = doc.createElement('div');
      el.setAttribute('data-toast', '');
      el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
      el.setAttribute('aria-live', kind === 'error' ? 'assertive' : 'polite');
      doc.body.appendChild(el);
    }
    el.textContent = message;
    el.className = 'toast is-visible' + (kind === 'error' ? ' toast--error' : '');
    clearTimeout(el._toastTimer);
    el._toastTimer = setTimeout(function () { el.className = 'toast'; }, 5000);
  }
  cfg.toast = toast;

  var Cart = (function () {
    var panel = doc.getElementById('bagPanel');
    var scrim = doc.getElementById('bagScrim');
    var itemsEl = doc.getElementById('bagItems');
    var emptyEl = doc.getElementById('bagEmpty');
    var subEl = doc.getElementById('bagSubtotal');
    var footEl = doc.getElementById('bagFoot');
    var statusEl = doc.getElementById('bagStatus');
    var cartUrl = routes.cart_url || '/cart';
    var onCartPage = !!(doc.body && doc.body.classList.contains('template-cart'));
    var useDrawer = !!panel && cfg.cartMode !== 'page' && !onCartPage;

    var ICON_MINUS = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
    var ICON_PLUS = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

    var modal = panel ? Modal({
      el: panel,
      show: function () {
        panel.removeAttribute('inert');
        panel.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
      },
      hide: function () {
        panel.classList.remove('is-open');
        panel.setAttribute('inert', '');
        if (scrim) scrim.classList.remove('is-open');
      },
      initialFocus: function () { return panel; },
      fallbackFocus: function () { return doc.querySelector('.nav__bag'); }
    }) : null;

    function announce(message) {
      if (!statusEl || !message) return;
      statusEl.textContent = '';
      setTimeout(function () { statusEl.textContent = message; }, 80);
    }

    function setCount(n) {
      doc.querySelectorAll('[data-cart-count]').forEach(function (el) {
        var changed = el.textContent.trim() !== String(n);
        el.textContent = n;
        el.hidden = n === 0;
        if (changed && n > 0 && !reduced() && el.classList.contains('nav__bag__count')) {
          el.classList.remove('is-bumped');
          void el.offsetWidth;
          el.classList.add('is-bumped');
        }
      });
      var label = str('cartCount');
      if (label) {
        doc.querySelectorAll('[data-cart-label]').forEach(function (el) {
          el.setAttribute('aria-label', fill(label, { count: n }));
        });
      }
    }

    var lineCtx = {};
    function lineHtml(item) {
      var title = item.product_title || item.title || '';
      var url = item.url || cartUrl;
      var src = item.image ? sized(item.image, 200) : kitThumb(item.handle, item.product_title);
      var img = src ? '<img src="' + esc(src) + '" alt="" width="100" height="100" loading="lazy">' : '';
      var meta = '';
      var kitLine = (window.SneakPen && window.SneakPen.kitContents) ? window.SneakPen.kitContents[item.handle] : '';
      if (kitLine) { meta += '<p class="bag__item__meta">' + esc(kitLine) + '</p>'; }
      var free = item.final_line_price === 0 && item.original_line_price > 0;
      (item.line_level_discount_allocations || []).forEach(function (d) {
        var t = d && d.amount > 0 && d.discount_application ? d.discount_application.title : '';
        var titles = (window.SneakPen && window.SneakPen.offerTitles) || {};
        if (t) meta += '<p class="bag__item__offer">' + esc(titles[t] || t) + '</p>';
      });
      var kc = lineCtx[item.product_id];
      if (kc && kc.qty === 2 && !kc.free && !kc.shown && str('thirdFree')) {
        kc.shown = true;
        meta += '<p class="bag__item__offer bag__item__next">' + esc(str('thirdFree')) + ' <button type="button" class="bag__next-add" data-quick-add="' + esc(item.variant_id) + '">' + esc(str('upsellAdd') || 'Add') + '</button></p>';
      }
      if (!item.product_has_only_default_variant && item.variant_title) {
        meta += '<p class="bag__item__meta">' + esc(item.variant_title) + '</p>';
      }
      var props = item.properties || {};
      Object.keys(props).forEach(function (k) {
        var v = props[k];
        if (k.charAt(0) === '_' || v == null || String(v).trim() === '') return;
        meta += '<p class="bag__item__meta">' + esc(k) + ': ' + esc(v) + '</p>';
      });
      var price = '';
      if (item.original_line_price > item.final_line_price) {
        price += (str('regularPrice') ? '<span class="visually-hidden">' + esc(str('regularPrice')) + '</span>' : '') + '<s>' + esc(formatMoney(item.original_line_price)) + '</s>';
      }
      price += free ? '<span class="bag__item__free">' + esc(str('free') || 'Free') + '</span>' : '<span>' + esc(formatMoney(item.final_line_price)) + '</span>';

      return '<li class="bag__item" data-key="' + esc(item.key) + '" data-quantity="' + (parseInt(item.quantity, 10) || 0) + '">' +
        '<a class="bag__item__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="bag__item__info">' +
          '<a class="bag__item__name" href="' + esc(url) + '">' + esc(title) + '</a>' + meta +
          '<div class="bag__item__actions">' +
            (free ? '<span class="bag__qty-fixed">× ' + (parseInt(item.quantity, 10) || 0) + '</span>' : '<div class="bag__qty" role="group" aria-label="' + esc(str('quantity')) + '">' +
              '<button type="button" class="bag__qty-btn" data-qty="dec" aria-label="' + esc(fill(str('qtyDown'), { title: title })) + '">' + ICON_MINUS + '</button>' +
              '<span class="bag__qty-val">' + (parseInt(item.quantity, 10) || 0) + '</span>' +
              '<button type="button" class="bag__qty-btn" data-qty="inc" aria-label="' + esc(fill(str('qtyUp'), { title: title })) + '">' + ICON_PLUS + '</button>' +
            '</div>') +
            '<button type="button" class="bag__remove" data-qty="remove" aria-label="' + esc(fill(str('removeItem'), { title: title })) + '">' + esc(str('remove')) + '</button>' +
          '</div>' +
        '</div>' +
        '<p class="bag__item__price">' + price + '</p>' +
      '</li>';
    }

    function render(cart) {
      if (!cart || !cart.items) return;
      setCount(cart.item_count);
      if (panel) {
        var empty = cart.item_count === 0;
        if (itemsEl) {
          lineCtx = {};
          (cart.items || []).forEach(function (it) {
            if (it.handle !== 'sneakpen' && it.handle !== 'sneakpen-solo') return;
            var k = lineCtx[it.product_id] || (lineCtx[it.product_id] = { qty: 0, free: false, shown: false });
            k.qty += it.quantity;
            if (it.final_line_price === 0 && it.original_line_price > 0) k.free = true;
          });
          itemsEl.innerHTML = empty ? '' : cart.items.map(lineHtml).join('');
          itemsEl.hidden = empty;
        }
        if (emptyEl) emptyEl.hidden = !empty;
        if (footEl) footEl.hidden = empty;
        if (subEl) subEl.textContent = formatMoney(cart.total_price);
        var wasEl = doc.getElementById('bagWas');
        if (wasEl) {
          var wasAmt = wasEl.querySelector('[data-bag-was]');
          var before = cart.original_total_price || 0;
          var showWas = (cart.total_discount || 0) > 0 && before > cart.total_price;
          if (wasAmt && showWas) wasAmt.textContent = formatMoney(before);
          wasEl.hidden = !showWas;
        }
        if (footEl) {
          var saveEl = footEl.querySelector('[data-bag-save]');
          var saved = cart.total_discount || 0;
          if (saved > 0 && str('saveAmount')) {
            if (!saveEl && subEl && subEl.parentElement) {
              saveEl = doc.createElement('p');
              saveEl.className = 'bag__save';
              saveEl.setAttribute('data-bag-save', '');
              subEl.parentElement.insertAdjacentElement('afterend', saveEl);
            }
            if (saveEl) { saveEl.textContent = fill(str('saveAmount'), { amount: formatMoney(saved) }); saveEl.hidden = false; }
          } else if (saveEl) {
            saveEl.hidden = true;
          }
        }
      }
      try { doc.dispatchEvent(new CustomEvent('sneakpen:cart', { detail: { cart: cart } })); } catch (e) {}
    }

    function refresh() {
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); return cart; })
        .catch(function () { return null; });
    }

    function open(opener) {
      if (!useDrawer || !modal) { window.location.href = cartUrl; return; }
      modal.open(opener);
    }
    function close() { if (modal) modal.close(); }

    function readResponse(r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }
    function errorFrom(data) {
      if (data && (data.description || data.message)) return data.description || data.message;
      return str('cartError');
    }

    function change(key, qty, li) {
      if (li) li.classList.add('is-busy');
      return fetch((routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(readResponse).then(function (res) {
        if (!res.ok) {
          toast(errorFrom(res.data), 'error');
          return refresh();
        }
        if (onCartPage) { window.location.reload(); return res.data; }
        render(res.data);
        announce(str('cartUpdated'));
        return res.data;
      }).catch(function () {
        if (li) li.classList.remove('is-busy');
        toast(str('cartError'), 'error');
      });
    }

    function add(formData, onDone, opener) {
      return fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(readResponse).then(function (res) {
        if (!res.ok) {
          toast(errorFrom(res.data), 'error');
          if (onDone) onDone(false);
          return;
        }
        if (onCartPage) { window.location.reload(); return; }
        if (!useDrawer) { window.location.href = cartUrl; return; }
        return refresh().then(function () {
          if (onDone) onDone(true);
          open(opener);
          announce(str('cartUpdated'));
        });
      }).catch(function () {
        toast(str('cartError'), 'error');
        if (onDone) onDone(false);
      });
    }

    function restoreFocus(key, action, index) {
      if (!modal || !modal.isOpen) return;
      var target = null;
      var li = itemsEl ? itemsEl.querySelector('[data-key="' + String(key).replace(/"/g, '\\"') + '"]') : null;
      if (li) target = li.querySelector('[data-qty="' + action + '"]') || li.querySelector('[data-qty]');
      if (!target && itemsEl && !itemsEl.hidden && itemsEl.children.length) {
        var next = itemsEl.children[Math.min(index, itemsEl.children.length - 1)];
        if (next) target = next.querySelector('.bag__item__name');
      }
      if (!target && emptyEl && !emptyEl.hidden) target = emptyEl.querySelector('a[href]');
      focusSafely(target || doc.getElementById('bagClose'));
    }

    doc.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var toggle = target.closest('[data-cart-toggle]');
      if (toggle) {
        if (!useDrawer) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        open(toggle);
        refresh();
        return;
      }
      if (modal && modal.isOpen && target.closest('[data-bag-close]')) {
        e.preventDefault();
        close();
      }
    });

    if (itemsEl) itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('button[data-qty]') : null;
      if (!btn) return;
      var li = btn.closest('.bag__item');
      if (!li || li.classList.contains('is-busy')) return;
      var key = li.getAttribute('data-key');
      var cur = parseInt(li.getAttribute('data-quantity'), 10) || 0;
      var action = btn.getAttribute('data-qty');
      var next = action === 'inc' ? cur + 1 : (action === 'dec' ? cur - 1 : 0);
      var index = Array.prototype.indexOf.call(itemsEl.children, li);
      change(key, Math.max(0, next), li).then(function () { restoreFocus(key, action, index); });
    });

    function cleanFormData(form) {
      var fd = new FormData(form);
      var drop = [];
      fd.forEach(function (value, key) {
        if (key.indexOf('properties[') === 0 && String(value).trim() === '') drop.push(key);
      });
      drop.forEach(function (key) { fd.delete(key); });
      return fd;
    }

    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[data-cart-form]')) e.preventDefault();
    }, true);

    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-cart-form]')) return;
      e.preventDefault();
      if (form.dataset.busy === '1') return;
      form.dataset.busy = '1';
      var btn = e.submitter || form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        if (str('adding')) btn.textContent = str('adding');
      }
      add(cleanFormData(form), function () {
        form.dataset.busy = '';
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
      }, btn);
    });

    doc.addEventListener('click', function (e) {
      var qa = e.target.closest ? e.target.closest('[data-quick-add]') : null;
      if (!qa) return;
      e.preventDefault();
      var id = qa.getAttribute('data-quick-add');
      if (!id || qa.dataset.busy === '1') return;
      qa.dataset.busy = '1';
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      var label = qa.innerHTML;
      qa.setAttribute('aria-disabled', 'true');
      qa.setAttribute('aria-busy', 'true');
      if (str('adding')) qa.textContent = str('adding');
      add(fd, function () {
        qa.dataset.busy = '';
        qa.removeAttribute('aria-disabled');
        qa.removeAttribute('aria-busy');
        qa.innerHTML = label;
      }, qa);
    });

    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    return { refresh: refresh, open: open, close: close, add: add, render: render };
  })();
  cfg.Cart = Cart;

  function initLocaleSuggest() {
    var bar = doc.querySelector('[data-locale-suggest]');
    if (!bar) return;

    var KEY = 'sneakpen:locale-suggested';
    try { if (window.localStorage.getItem(KEY)) return; } catch (e) {}

    function remember() {
      try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
    }

    var current = (bar.getAttribute('data-current') || '').toLowerCase().split('-')[0];
    var wanted = (navigator.languages && navigator.languages.length)
      ? navigator.languages
      : [navigator.language || ''];

    var match = null;
    for (var i = 0; i < wanted.length && !match; i++) {
      var tag = String(wanted[i]).toLowerCase().split('-')[0];
      if (!tag || tag === current) break; // la langue préférée est déjà servie
      match = bar.querySelector('[data-locsug-lang^="' + tag + '"]');
    }
    if (!match) return;

    match.hidden = false;
    bar.hidden = false;
    void bar.offsetWidth; // commit the hidden state so the slide-in really runs
    bar.classList.add('is-open');

    match.addEventListener('click', remember);
    var dismiss = bar.querySelector('[data-locsug-dismiss]');
    if (dismiss) dismiss.addEventListener('click', function () {
      remember();
      bar.classList.remove('is-open');
      if (reduced()) bar.hidden = true;
      else setTimeout(function () { bar.hidden = true; }, 400);
    });
  }

  function initFormStatus() {
    var statuses = doc.querySelectorAll('[data-form-status]');
    if (!statuses.length) return;
    var id = '';
    try { id = decodeURIComponent((window.location.hash || '').slice(1)); } catch (e) {}
    var target = id ? doc.getElementById(id) : null;
    if (!target || !target.querySelector('[data-form-status]')) return;
    statuses.forEach(function (el) {
      if (target.contains(el)) return;
      el.hidden = true;
      var form = el.closest('form');
      if (form) {
        form.querySelectorAll('[aria-invalid]').forEach(function (field) { field.removeAttribute('aria-invalid'); });
      }
    });
  }

  function initCookiePrefs() {
    var items = doc.querySelectorAll('[data-cookie-prefs-item]');
    if (!items.length) return;
    function own() {
      var sp = window.SneakPen;
      return sp && typeof sp.cookiePrefs === 'function' ? sp.cookiePrefs : null;
    }
    function shopify() {
      var pb = window.privacyBanner;
      return pb && typeof pb.showPreferences === 'function' ? pb : null;
    }
    function reveal() {
      if (!own() && !shopify()) return false;
      items.forEach(function (el) { el.hidden = false; });
      return true;
    }
    doc.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cookie-prefs]') : null;
      if (!btn) return;
      var mine = own();
      if (mine) { e.preventDefault(); mine(); return; }
      var pb = shopify();
      if (pb) { e.preventDefault(); pb.showPreferences(); }
    });
    if (reveal()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (reveal() || tries > 12) clearInterval(timer);
    }, 750);
  }

  function boot() {
    initNav();
    initMenu();
    initSearch();
    initReveals();
    initLocaleSuggest();
    initFormStatus();
    initCookiePrefs();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
